import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import { SetStateAction } from "react";

export type PreviewChatImgProps = CustomComponentProps & {
    // open:boolean;
    setPreviewImg: React.Dispatch<SetStateAction<string | undefined>>;
    src: string;
};
const PreviewChatImg = ({ setPreviewImg, src }: PreviewChatImgProps) => {
    return (
        <div className="profile-followers-card card d-flex flex-col gap-5 preview-img-div">
            <div className="w-full pt-10 pb-10 pr-20 d-flex flex-j-end">
                <div onClick={() => setPreviewImg(undefined)}>
                    <SVG svg="close" size={20} />
                </div>
            </div>
            <div className="d-flex flex-j-center flex-a-center pr-10 pl-10 pt-10 pb-10 h-full">
                <img className="preview-image" src={src} alt="preview image" />
            </div>
        </div>
    );
};

export default PreviewChatImg;
